import type { TFunction } from '@/types'

export const responseMessageFromStatus = (t: TFunction, status: number | string | null | undefined): string | undefined => {
  const code: number = Number(status)
  if (!Number.isFinite(code)) return undefined

  const msg: string = t(`responses.${code}`, { defaultValue: '' })
  return msg || undefined
}
